import * as yup from 'yup';

const validationSchema = () =>
  yup.object().shape({
    name: yup.string().nullable(),
  });

export default validationSchema;
